import { combineReducers } from 'redux'
import * as loca  from './location'
import { reducer as formReducer } from 'redux-form'

export let initReducers = {
  location: loca.locationReducer,
  form: formReducer
}

export const makeRootReducer = (reducers = {}) => {
  initReducers = { ...initReducers, ...reducers }
  return combineReducers({
    ...initReducers
  })
}



export let  InjectReducerManager = {
  store:{},
  with: function(store){
    this.injectReducer = this.create(store) ;
    this.store = store
  },
  create:(store) => ({ key, reducer, ...reducers }) => {
    if (Object.hasOwnProperty.call(store.asyncReducers, key)) return
    if(!key) {
      Object.keys(reducers).forEach(key => {
        store.asyncReducers[key] = reducers[key]
      })
    }  else {
      store.asyncReducers[key] = reducer
    }
    store.replaceReducer(combineReducers({...initReducers, ...store.asyncReducers}))
  },
  injectReducer:null
}

/*export const injectReducer = (store, { key, reducer, ...reducers }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return
  if(!key) {
    Object.keys(reducers).forEach(key => {
      store.asyncReducers[key] = reducers[key]
    })
  }  else {
    store.asyncReducers[key] = reducer
  }

  store.replaceReducer(combineReducers({...initReducers, ...store.asyncReducers}))
}*/
export const injectReducer = ({ key, reducer, ...reducers }) => {
  InjectReducerManager.injectReducer({ key, reducer, ...reducers })
}



export function createReducer() {
  return function reducer(initState = {}) {
    return (state = initState, action = {}) => {
      const handler = reducer[action.type]
      if(!handler) { return state }

      return handler(state, action.result || action.error)
    }
  }
}



export function action({ type, action, handler  }, reducerCreator) {
  const { REQUEST, SUCCESS, FAILURE } = types(type)

  reducerCreator[REQUEST] = (state, result) => ({
    ...state,
    [`${type}.pending`]: true,
    [`${type}.error`]: undefined
  })

  reducerCreator[SUCCESS] = (state, result) => ({
    ...handler(state, result),
    [`${type}.pending`]: false,
    [`${type}.error`]: undefined
  })

  reducerCreator[FAILURE] = (state, error) => ({
    ...handler(state),
    [`${type}.pending`]: false,
    [`${type}.error`]: error
  })

  return (...args) => ({
    type,
    promise: (http, dispatch, getState) => action.apply(this, args.concat([http, dispatch, getState]))
  })
}

export function mergeHandle(...handles) {
  const handle = handles.reduce((acc, next) => ({...acc, ...next}))

  return (state = initState, action = {}) => {
    const handler = handle[action.type]
    if(!handler) { return state }

    return handler(state, action.result || action.error)
  }
}

export function types(type) {
  return {
    REQUEST: `async.action.request.${type}`,
    SUCCESS: `async.action.success.${type}`,
    FAILURE: `async.action.failure.${type}`
  }
}



// WEBPACK FOOTER //
// ../~/shared/src/utils/redux/reducer.js